/**
 * Environment configuration
 * Loads from .env file via Vite's import.meta.env
 */

export const config = {
  api: {
    // Empty means same-origin. The hosted site proxies /v1 to Nexus.
    baseUrl: import.meta.env.VITE_API_BASE_URL || '',
    wsUrl: import.meta.env.VITE_WS_URL || '',
  },
  realtime: {
    // SSE URL - empty by default for LocalStack (uses polling fallback)
    sseUrl: import.meta.env.VITE_SSE_URL || '',
  },
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_6Z5LrXkBB',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '3ctgelm221jjf9oq2la2h693ct',
    region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
  },
  env: import.meta.env.VITE_ENV || 'dev',
} as const;

if (!config.api.wsUrl) {
  console.log('📭 WebSocket disabled - using polling');
} else {
  console.log(`🔌 WebSocket enabled: ${config.api.wsUrl}`);
}

if (!config.cognito.userPoolId || !config.cognito.clientId) {
  console.warn('⚠️ Cognito configuration incomplete');
}

